import { createState } from "@hookstate/core";
const networkState = createState({
  calling: 0,
  requesting: 0,
});

export default networkState;
